import React, { FC } from 'react';
import { useRouter } from 'next/router';
import { styled } from 'linaria/react';
import { noop } from 'lodash';
import { useCurrentTspOnly } from '@shared/lib';
import { Text } from '@shared/ui/atoms';
import { RejectIcon } from '@shared/assets/icons';
import { withTheme } from '@shared/lib/theme';
import { Button } from '@shared/ui/molecules';
import { useIsClient } from '@shared/lib/react';
const FailedToDisplay: FC = () => {
  const router = useRouter();
  const {
    isCurrentTspOnly
  } = useCurrentTspOnly();
  const isClient = useIsClient();
  const handleRedirectButtonClick = () => {
    router.push(isCurrentTspOnly && router.query.url ? `/${router.query.url}` : '/').then(noop);
  };
  return <FailedToDisplayWrapper>
      <IconWrapper>
        <RejectIcon />
      </IconWrapper>
      <TextWrapper>
        <Text family="MTSWide" size={{
        desktop: 'h5',
        mobile: 'h6'
      }} weight="bold" color="primary" textTransform="none" style={{
        textAlign: 'center'
      }}>
          Не удалось
          <br />
          отобразить статус операции
        </Text>
        <Text family="MTSCompact" size={{
        desktop: 'pL',
        mobile: 'pM'
      }} weight="medium" color="secondary" style={{
        textAlign: 'center'
      }}>
          Проверьте его в&nbsp;истории операций в&nbsp;банке, картой которого вы&nbsp;платили
        </Text>
      </TextWrapper>
      {isClient && <Button variant="primary" onClick={handleRedirectButtonClick}>
          {router.query.url ? 'Продолжить' : 'На главную'}
        </Button>}
    </FailedToDisplayWrapper>;
};
export default FailedToDisplay;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.secondary;
const FailedToDisplayWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "FailedToDisplayWrapper",
  class: "f1o60gh7",
  propsAsIs: false,
  vars: {
    "f1o60gh7-0": [_exp()]
  }
}));
const IconWrapper = /*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "i1l7708f",
  propsAsIs: false
});
const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "t6hza9c",
  propsAsIs: false
});

require("./FailedToDisplay.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./FailedToDisplay.tsx");